// Staggered entrance animations on load
// Uses IntersectionObserver for scroll-triggered reveals

export default function initAnimations() {
    // Elements that animate on page load (above the fold)
    const loadElements = document.querySelectorAll('.gh-anim-load');
    loadElements.forEach((el, i) => {
        el.style.animationDelay = `${0.1 + i * 0.12}s`;
        el.classList.add('gh-anim-active');
    });

    // Elements that animate when scrolled into view
    const scrollElements = document.querySelectorAll('.gh-anim-scroll');
    if (scrollElements.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('gh-anim-active');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.1,
        rootMargin: '0px 0px -40px 0px'
    });

    scrollElements.forEach(el => observer.observe(el));
}
